export default "__VITE_ASSET__BmP9rjUg__"